export const useBreadcrumbsStore = defineStore('breadcrumbsStore', {
  state: () => ({
    crumbs: [],
    hidden: false
  }),
  actions: {
    async set(crumbs = []) {
      this.crumbs = crumbs
      this.hidden = false
    },
    hide() {
      this.hidden = true
    },
    show() {
      this.hidden = false
    }
  }
})
